import React from 'react';
import AlloyRepairRequest from './AlloyRepairRequest';
import {
    AlloyPageState,
    AlloyProcessStages,
    AlloyTypes
} from './AlloyRepairRequestTypes';
import { SelectInputHelper } from '../../common/selectInput/SelectInput';
import './AlloyRepairRequest.scss';
import AlloyRepairRequestProvider from '../../../context/AlloyRepairRequestProvider';
import ReloadHandler from '../../common/ReloadHandler';
import { Locations, RoutePaths } from '../../../Constants/Common';
import { useSelectedProduct } from '../../hooks/useSelectedProduct';
import { useSelectedVehicle } from '../../hooks/useSelectedVehicle';
import { useTranslation } from 'react-i18next';

const AlloyRepairRequestManager = (): JSX.Element => {
    const { i18n } = useTranslation();

    const isSiteLocationUs = i18n.language?.toLowerCase() === Locations.Us;

    const initialState: AlloyPageState = {
        alloyType: isSiteLocationUs
            ? AlloyTypes.StandardAlloy
            : SelectInputHelper.NullValue(),
        mileage: '',
        alloyWheelRepairRequests: [],
        alloyFormErrors: undefined,
        repairRequestSelectedIndex: -1,
        alloyStage: AlloyProcessStages.General,
        repairAddresses: [],
        repairAddressSelectedIndex: -1,
        hasErrors: false,
        permissionGranted: false,
        selectedWheels: [],
        currentRepairRequest: undefined,
        showCancelAlert: false,
        updateWheel: '',
        scrollToAddress: false,
        isLoadingOnSubmission: false
    };

    const vehicle = useSelectedVehicle();
    const { product } = useSelectedProduct();

    return (
        <AlloyRepairRequestProvider
            initialState={initialState}
            product={product}
            vehicle={vehicle}>
            <AlloyRepairRequest />
            <ReloadHandler reloadPath={RoutePaths.LandingPage} />
        </AlloyRepairRequestProvider>
    );
};

export default AlloyRepairRequestManager;
